/**
 * Single logger seam for the app (React_TypeScript_Standards §6.2).
 * All feature code logs through here — never call console.* directly
 * (`no-console` is enforced everywhere except this file). When
 * centralized shipping (App Insights → Event Hub → Splunk) is wired
 * up, only this file changes.
 */
type LogLevel = 'info' | 'warn' | 'error'
type LogMeta = Record<string, unknown>

function emit(
  level: LogLevel,
  scope: string,
  message: string,
  meta?: LogMeta,
): void {
  // Meta is nested (not spread) so user-supplied keys can't shadow framework
  // keys like `scope` and `message`. Splunk searches use `meta.error.message`.
  const payload = { scope, message, ...(meta ? { meta } : {}) }
  /* eslint-disable no-console -- the logger wrapper is the one sanctioned console seam */
  if (level === 'error') console.error(payload)
  else if (level === 'warn') console.warn(payload)
  else console.info(payload)
  /* eslint-enable no-console */
}

export const logger = {
  scoped: (scope: string) => ({
    info: (message: string, meta?: LogMeta) =>
      emit('info', scope, message, meta),
    warn: (message: string, meta?: LogMeta) =>
      emit('warn', scope, message, meta),
    error: (message: string, meta?: LogMeta) =>
      emit('error', scope, message, meta),
  }),
}
